import React from "react";
import InvoiceTable from "../../../components/invoice/InvoiceTable";
import InvoiceContent from "../../../components/invoice/InvoiceContent";

function TransactionsInvoiceSection() {
  return (
    <div className="flex w-full flex-col">
      <InvoiceContent />
    </div>
  );
}

export default TransactionsInvoiceSection;
